// Scope + URL base for canvas API. Kept free of i18n / fetch so node:test
// (canvas-generation-url.test.ts) can import href helpers without Vite glob.

export type CanvasApiScope = { kind: "project"; projectId: number } | { kind: "company"; companyId?: number }

export function canvasApiBase(scope: CanvasApiScope): string {
  return scope.kind === "company" ? "/company/canvas" : `/projects/${scope.projectId}/workspace/canvas`
}

export function resolveCanvasApiScope(scopeOrProjectId: CanvasApiScope | number): CanvasApiScope {
  return typeof scopeOrProjectId === "number" ? { kind: "project", projectId: scopeOrProjectId } : scopeOrProjectId
}
